export const SET_IS_MENU_OPEN = 'SET_IS_MENU_OPEN';
